<div class="ss-breadcrumb">
    <h5>
        <ng-content select="app-breadcrumb[top]"></ng-content>
    </h5>
    <h6>
        <ng-content select="app-breadcrumb[bottom]"></ng-content>
    </h6>
</div>
